import AuthorProfileLayout from "@app/layouts/AuthorProfileLayout/AuthorProfileLayout";
import ErrorLayout from "@app/layouts/ErrorLayout/ErrorLayout";
import { AuthorData, AuthorProfileData } from "@app/types/ServerCustomContext";
import MetaData from "@components/Modules/MetaData";
import { mapErrorDataToMetaData } from "@components/Modules/MetaData/mappers";
import PubBaseLayout from "@pub/BaseLayout";
import { configAuthorProfile } from "@pub/config";
import { Route } from "@route-types/AuthorProfile/+types/AuthorProfile";
import { GlobalBaseData } from "@sphtech/dmg-design-system";
import {
  ResponseType,
  TRouteWithoutRedirect,
  TRouteWithRedirect,
} from "@sphtech/web2-core/ssr";
import { dataLoader } from "@src/app/utils/dataLoader";
import { useLoaderData } from "react-router";

import { fetchAuthorProfileData } from "./AuthorProfile.server";

export const meta = ({
  loaderData,
  location,
}: {
  loaderData: TRouteWithRedirect<AuthorProfileData, string>;
  location: { pathname: string };
}) => {
  if (loaderData.type !== ResponseType.SUCCESS) {
    const errorData = mapErrorDataToMetaData(loaderData, location);
    return MetaData(errorData);
  }

  const payload = loaderData.payload;
  const { name, description, urlPath } = payload;

  return MetaData({
    type: "CollectionPage",
    title: name,
    description,
    path: urlPath,
  });
};

export default function AuthorProfile() {
  const response: TRouteWithoutRedirect<AuthorProfileData, string> =
    useLoaderData();

  if (response.type !== ResponseType.SUCCESS) {
    return <ErrorLayout response={response} />;
  }

  return (
    <PubBaseLayout leaderboard={false} ads={!configAuthorProfile.hideAds}>
      <AuthorProfileLayout context={response.payload} />
    </PubBaseLayout>
  );
}

export async function loader({
  params,
}: Route.LoaderArgs): Promise<
  TRouteWithRedirect<AuthorData | GlobalBaseData, GlobalBaseData | string>
> {
  const data = await fetchAuthorProfileData(`/authors/${params.author}`);

  return await dataLoader({
    type: data.type,
    dataSource: data,
  });
}
